"use client";

// Miscellaneous client-side API functions (one-off or rare)
import { GetAllBrandsDocument } from "../generated/graphql";
import { localeConstants } from "@/apiUtils/constants";
import { getClientCookie } from "@/utils/common";
import { Brands } from "@/common/lib/types";
import PublicSaleorClient from "./PublicSaleorClient";

/**
 * Client-side function to get all brands
 * @param first Number of items to fetch
 * @param filter Filter criteria for brands
 * @returns Promise<Brands | null>
 */
export async function getAllBrandsClient(
  first: number,
  filter: { slugs?: string[]; ids?: string[] }
): Promise<Brands | null> {
  try {
    const saleorClient = new PublicSaleorClient();
    const locale = getClientCookie(localeConstants.NEXT_LOCALE) || "";

    if (!first) {
      return null;
    }

    await saleorClient.init(locale);

    const response: { data: { brands: Brands }; errors: unknown } = await saleorClient.post(
      `${GetAllBrandsDocument}`,
      {
        first,
        filter,
        locale: locale === "ar" ? "AR" : "EN",
      },
      "no-store"
    );

    if (response?.errors) {
      return null;
    }

    return response?.data?.brands || null;
  } catch (error) {
    console.error("Error fetching brands:", error);
    return null;
  }
} 